import React, { useEffect, useState } from 'react'

import CoachLayout from "../../layouts/CoachLayout";
import MenuLayout from "../../layouts/MenuLayout";
import { useNavigate } from 'react-router-dom';
import { coachPaths } from '../../routes/coach';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCoachList } from '../../redux/features/coach/actions/coachAction';
import Loader from '../../components/loader';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import EBookSlider from '../../components/slider/EBookSlider';
import { getAllEBooksListCoach } from '../../redux/features/coach/actions/authAction';
import { curSym } from '../../utils/pip';

const BusinessCoaching = () => {
  const user = { name: "business-coaching", role: "coach" };
  const { isLoading2, coachList } = useSelector((state) => state.coach.coach);
  const { isLoading, getAllEBookList } = useSelector((state) => state.coach.auth);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [navBarDemo, setNavBarDemo] = useState("Strategic");

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    dispatch(fetchCoachList());
    dispatch(getAllEBooksListCoach({ payload: "?content_type=eBook&category_id=5" }));

  }, []);

  const displayUsers = coachList?.filter((item) => {
    const matchCoachingType =
      item?.category_name
        ?.toLowerCase()
        .includes("business");
    return matchCoachingType;
  });

  if (isLoading2 && isLoading) {
    return <Loader />
  };
  return (
    <MenuLayout user={user}>
      <section
        class="ct_px_40 mt-4   ct_dark_sky_bg py-5"
        style={{ backgroundColor: "#219EBC" }}
      >
        <div class="container-fluid">
          <div class="row align-items-center">
            <div
              class="col-xxl-7 col-xl-7 col-md-8 mb-4 mb-md-0 "
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div class="ct_px_40 ct_px_0_767">
                <h2
                  class="ct_fs_50_new mb-4 text-white"
                  style={{ maxWidth: "600px" }}
                >
                  {" "}
                  Move from Hustle to
                  <span class="ct_darkblue_text"> Smart </span> Execution
                </h2>
                <p
                  class="mb-0 mt-3 ct_fs_20 text-white "
                  style={{ maxWidth: "638px" }}
                >
                  Sharpen your business vision, streamline your operations, and
                  implement strategies that scale without the chaos.
                </p>
                <div class="ct_mt_40">
                  <a
                    onClick={() =>
                      navigate(coachPaths.FindCoach, {
                        state: { data: "Business" },
                      })
                    }
                    class="ct_yellow_btn ct_darkblue_btn   px-5 ct_fit_content ct_h_48 "
                  >
                    Find a Coach
                  </a>
                </div>
              </div>
            </div>
            <div
              class="col-xxl-5 col-xl-5 col-md-4 mb-4 mb-md-0"
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <div class="ct_boocamp_img_left">
                <img
                  src="assets/img/pexels-blue-bird-7243007_8598.png"
                  alt=""
                  class="ct_img_h_458 w-100"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ct_py_65">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <h4 className="ct_fs_24_new mb-4 text-center">
                Join the 1,200+ companies growing with us{" "}
              </h4>
              <Swiper
                modules={[Navigation, Autoplay]}
                spaceBetween={20}
                slidesPerView={4}
                navigation
                autoplay={{ delay: 2500 }}
                loop={true}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  600: { slidesPerView: 2 },
                  900: { slidesPerView: 3 },
                  1200: { slidesPerView: 4 },
                }}
                className="ct_become_coach_slider"
              >
                <SwiperSlide>
                  <img src="assets/img/client_logo_3.png" alt="" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="assets/img/client_logo_4.png" alt="" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="assets/img/client_logo_5.png" alt="" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="assets/img/client_logo_6.png" alt="" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="assets/img/client_logo_7.png" alt="" />
                </SwiperSlide>
                <SwiperSlide>
                  {/* <div class="item"> */}
                  <img src="assets/img/client_logo_8.png" alt="" />
                  {/* </div> */}
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </section>

      <section
        class=" ct_py_100  ct_px_40 "
        style={{ backgroundColor: "hsl(32deg 100% 49% / 20%)" }}
      >
        <div class="container-fluid">
          <div class="row">
            <div
              class="col-lg-5 mb-4 mb-lg-0"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div class="ct_img_unlock_img_23">
                <div class="ct_img_unlock_img_23_left">
                  <img src="assets/img/509.png" alt="" />
                  <img src="assets/img/510.png" alt="" />
                </div>
                <div class="ct_img_unlock_img_23_right">
                  <img src="assets/img/511.png" alt="" />
                  <img src="assets/img/512.png" alt="" />
                </div>
              </div>
            </div>
            <div
              class="col-lg-7 mb-4 mb-lg-0 ps-lg-5"
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <h4 class="ct_fs_40 ct_orange_text" style={{ maxWidth: "647px" }}>
                {" "}
                Is Strategic Business Coaching Right for You?
              </h4>
              <ul className="ct_pt_40">
                <li>
                  <h4 className="ct_fs_24_new ct_darksky_blue_text mb-2">
                    {" "}
                    Unclear Business Direction
                  </h4>
                  <p className="mb-0 ct_fs_20" style={{ maxWidth: "684px" }}>
                    You have goals and ideas, but the path forward isn’t clear.
                    Strategic business coaching helps you define priorities,
                    align your vision, and create a roadmap for action.
                  </p>
                </li>
                <li className="mt-4">
                  <h4 className="ct_fs_24_new ct_darksky_blue_text mb-2">
                    Messy Execution Plan
                  </h4>
                  <p className="mb-0 ct_fs_20" style={{ maxWidth: "684px" }}>
                    You know what success looks like, but turning strategy into
                    results feels overwhelming. We help you structure, validate,
                    and implement plans that drive measurable growth.
                  </p>
                </li>
                <li className="mt-4">
                  <h4 className="ct_fs_24_new ct_darksky_blue_text mb-2">
                    Operating in Isolation
                  </h4>
                  <p className="mb-0 ct_fs_20" style={{ maxWidth: "684px" }}>
                    Running a business alone or with a small team can feel
                    isolating. With a coach, you gain expert guidance,
                    accountability, and the support needed to make confident
                    decisions.
                  </p>
                </li>
                <li className="mt-4">
                  <h4 className="ct_fs_24_new ct_darksky_blue_text mb-2">
                    Overloaded and Stretched
                  </h4>
                  <p className="mb-0 ct_fs_20" style={{ maxWidth: "698px" }}>
                    You’re balancing strategy, operations, and growth
                    challenges. Strategic business coaching brings focus,
                    clarity, and efficiency — helping you make high-impact
                    decisions without burnout.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class=" ct_px_40 ct_py_130">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div
              class="col-lg-8 mb-4 mb-lg-0"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div class="ct_how_work_content">
                <h4 class="ct_fs_32 ct_yellow_text">How it Works?</h4>
                <h3 class="ct_fs_40 ">
                  Simple steps to get the support you need
                </h3>
              </div>
              <div class="row mt-5">
                <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                  <div class="ct_how_work_card">
                    <img
                      src="assets/img/ri_find-replace-fill_orange.png"
                      alt=""
                      className="ct_w_50_340"
                    />
                    <div class="pt-4">
                      <h5 className="ct_fs_20 ct_darksky_blue_text ct_fw_600 mb-4">
                        Choose Your Coach Pack
                      </h5>
                      <p class="mb-0 ct_fs_16" style={{ maxWidth: "254px" }}>
                        Select the coach and plan that fits your current stage
                        whether you need quick clarity or full launch support.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                  <div class="ct_how_work_card">
                    <img
                      src="assets/img/fa6-solid_handshake_orange.png"
                      alt=""
                      className="ct_w_50_340"
                    />
                    <div class="pt-4">
                      <h5 className="ct_fs_20 ct_darksky_blue_text ct_fw_600 mb-4">
                        Book Your Sessions
                      </h5>
                      <p class="mb-0 ct_fs_16" style={{ maxWidth: "254px" }}>
                        Schedule your sessions at your own pace, with guidance
                        from a dedicated coach.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                  <div class="ct_how_work_card">
                    <img
                      src="assets/img/uim_bag_orange.png"
                      alt=""
                      className="ct_w_50_340"
                    />
                    <div class="pt-4">
                      <h5 className="ct_fs_20 ct_darksky_blue_text ct_fw_600 mb-4">
                        Take Action with Support
                      </h5>
                      <p class="mb-0 ct_fs_16" style={{ maxWidth: "263px" }}>
                        Work through your ideas, mindset, and strategy and move
                        forward with a clear, confident plan.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-lg-4 mb-4 mb-lg-0 "
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <div class="ct_how_work_img">
                <img src="assets/img/Rectangle_4187_8963.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="ct_px_40 ct_Connect_with_Founder_bg">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center">
                <h4 className="ct_fs_40 ct_darksky_blue_text mb-3">
                  Connect with Business Coaches
                </h4>
                <p
                  className="ct_fs_24_new mx-auto"
                  style={{ maxWidth: "1100px" }}
                >
                  Experienced mentors guiding you to clarify your vision,
                  structure your strategy, and accelerate growth with
                  confidence.
                </p>
              </div>
              <div
                className="row ct_mt_60 pt-4"
                data-aos="fade-down"
                data-aos-duration="1500"
              >
                <Swiper
                  modules={[Navigation, Autoplay]}
                  spaceBetween={20}
                  slidesPerView={5}
                  navigation
                  autoplay={{ delay: 2500 }}
                  loop={true}
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    600: { slidesPerView: 2 },
                    900: { slidesPerView: 3 },
                    1200: { slidesPerView: 5 },
                  }}
                  className="ct_become_coach_slider"
                >
                  {displayUsers?.length != 0 &&
                    displayUsers?.map((item) => (
                      <SwiperSlide>
                        <figure
                          className="ct_featured_coach_card ct_cursor_pointer"
                          onClick={() =>
                            navigate(`/coach-profile/${item?.coach_id}`
 , {
                              state: { data: item },
                            })
                          }
                        >
                          <div className="ct_featured_card_img">
                            <img
                              src={
                                item?.profile_image ??
                                "assets/img/Featured_Coaches_img_9.png"
                              }
                              alt=""
                            />
                          </div>
                          <figcaption>
                            <h4 className="ct_fs_20 mb-1">
                              {item?.full_name ?? ""}
                            </h4>
                            <p className="mb-0 ct_grey_text">
                              {item?.category_name ?? ""} Coach
                            </p>
                          </figcaption>
                        </figure>
                      </SwiperSlide>
                    ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="ct_py_100  ct_px_40  ct_mt_60">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <div class="text-center">
                <h4 class="ct_fs_40 ct_yellow_text mb-3">
                  Connect with Business Strategy Coaches
                </h4>
                <p
                  class="mb-0 ct_fs_20_new mx-auto"
                  style={{ maxWidth: "1091px" }}
                >
                  Experienced mentors helping you clarify your vision, refine
                  your strategy, and make confident decisions to grow your
                  business with purpose and impact.
                </p>
              </div>
            </div>
          </div>
          <div class="row mt-5" data-aos="fade-down" data-aos-duration="1500">
            <div class="col-md-12">
              <ul
                class="nav nav-pills mb-3 ct_custom_tabs w-100"
                style={{
                  backgroundColor: `${
                    navBarDemo == "Founder"
                      ? "var(--#219EBC)"
                      : navBarDemo == "Executive"
                        ? "var(--yellow)"
                        : navBarDemo == "Team_Coaching"
                          ? "var(--orange)"
                          : navBarDemo == "Performance"
                            ? "#023047"
                            : navBarDemo == "Strategic"
                              ? "#8ECAE6"
                              : navBarDemo == "Personal_Coaching" && "#219EBC"
                  }`,
                }}
                id="pills-tab"
                role="tablist"
              >
                <li class="nav-item" role="presentation">
                  <button
                    class={`nav-link ${navBarDemo == "Founder" && "active"}`}
                    id="pills-Founder-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-Founder"
                    type="button"
                    role="tab"
                    onClick={() => setNavBarDemo("Founder")}
                    aria-controls="pills-Founder"
                    aria-selected="true"
                  >
                    Founder
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class={`nav-link ${navBarDemo == "Executive" && "active"}`}
                    id="pills-Executive-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-Executive"
                    type="button"
                    role="tab"
                    onClick={() => setNavBarDemo("Executive")}
                    aria-controls="pills-Executive"
                    aria-selected="false"
                    tabindex="-1"
                  >
                    Executive & Leadership
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class={`nav-link ${navBarDemo == "Team_Coaching" && "active"
                      }`}
                    id="pills-Team_Coaching-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-Team_Coaching"
                    onClick={() => setNavBarDemo("Team_Coaching")}
                    type="button"
                    role="tab"
                    aria-controls="pills-Team_Coaching"
                    aria-selected="false"
                    tabindex="-1"
                  >
                    Team
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class={`nav-link ${navBarDemo == "Performance" && "active"
                      }`}
                    id="pills-Performance-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-Performance"
                    onClick={() => setNavBarDemo("Performance")}
                    type="button"
                    role="tab"
                    aria-controls="pills-Performance"
                    aria-selected="false"
                    tabindex="-1"
                  >
                    Performance
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class={`nav-link ${navBarDemo == "Strategic" && "active"}`}
                    id="pills-Strategic-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-Strategic"
                    onClick={() => setNavBarDemo("Strategic")}
                    type="button"
                    role="tab"
                    aria-controls="pills-Strategic"
                    aria-selected="false"
                    tabindex="-1"
                  >
                    Strategic Business
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class={`nav-link ${navBarDemo == "Personal_Coaching" && "active"
                      }`}
                    id="pills-Personal_Coaching-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-Personal_Coaching"
                    onClick={() => setNavBarDemo("Personal_Coaching")}
                    type="button"
                    role="tab"
                    aria-controls="pills-Personal_Coaching"
                    aria-selected="false"
                    tabindex="-1"
                  >
                    Personal
                  </button>
                </li>
              </ul>
              <div class="tab-content mt-5" id="pills-tabContent">
                <div
                  class={`tab-pane fade ${navBarDemo == "Founder" && "active show"
                    }`}
                  id="pills-Founder"
                  role="tabpanel"
                  aria-labelledby="pills-Upcoming-tab"
                >
                  <div class="row">
                    <div class="col-lg-8 mb-4 mb-lg-0">
                      <div class="ct_">
                        <h4 class="ct_fs_32 ct_orange_text ">
                          Founder Packages
                        </h4>
                        <p class="mb-0 ct_fs_20" style={{ maxWidth: "768px" }}>
                          Designed for solopreneurs and founders who want to
                          turn great ideas into tangible results with focus,
                          structure, and drive.
                        </p>
                      </div>
                      <div class="row mt-5">
                        <div class="col-lg-6  mb-4 mb-lg-0">
                          <div
                            class="ct_pricing_card"
                            style={{ borderColor: "#8ECAE6" }}
                          >
                            <div>
                              <div class="ct_pricing_title mt-3 text-start">
                                <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                  Clarity Pack
                                </p>
                                <h2 class="ct_fs_44  mb-0 ct_fw_600">{curSym} 259</h2>
                                <p class="mb-0 mt-2 ct_fs_20 ct_orange_text">
                                  For solopreneurs
                                </p>
                              </div>
                              <ul class="ct_mt_30 mb-4 mt-4">
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  2 × 60-min sessions
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Business model snapshot
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  30-day focus plan
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Email check-in
                                </li>
                              </ul>
                            </div>
                            <div class="mt-auto pt-5">
                              <a
                                class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48"
                                onClick={() =>
                                  navigate(coachPaths.FindCoach, {
                                    state: { data: "Business" },
                                  })
                                }
                              >
                                Choose Your Coach
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6 mb-4 mb-lg-0">
                          <div
                            class="ct_pricing_card"
                            style={{ borderColor: "#8ECAE6" }}
                          >
                            <div>
                              <div class="ct_pricing_title mt-3 text-start">
                                <div class="d-flex align-items-center justify-content-between gap-2 mb-0">
                                  <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                    Launch Pack
                                  </p>
                                  <span
                                    class="ct_most_popular_badge ct_flex_shrink_0"
                                    style={{
                                      backgroundColor: "var(--yellow) ",
                                      color: "var(--darkblue)",
                                    }}
                                  >
                                    Most Popular
                                  </span>
                                </div>
                                <h2 class="ct_fs_44  mb-0 ct_fw_600">{curSym} 599</h2>
                                <p
                                  class="mb-0 mt-2 ct_fs_20 ct_orange_text"
                                  style={{ maxWidth: "261px" }}
                                >
                                  For early-stage entrepreneurs.
                                </p>
                              </div>
                              <ul class="ct_mt_30 mb-4 mt-4">
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  5 × sessions
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Vision, offer & strategy mapping
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Confidence + mindset coaching
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Resource toolkit (Notion templates, guides)
                                </li>
                              </ul>
                            </div>
                            <div class="mt-auto">
                              <a
                                class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48"
                                onClick={() =>
                                  navigate(coachPaths.FindCoach, {
                                    state: { data: "Business" },
                                  })
                                }
                              >
                                Choose Your Coach
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 mb-4 mb-lg-0 ps-lg-3">
                      <div class="ct_about_img">
                        <img
                          src="assets/img/Rectangle_4187_new_233.png"
                          alt=""
                          class="ct_img_h_641"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${navBarDemo == "Executive" && "active show"
                    }`}
                  id="pills-Executive"
                  role="tabpanel"
                  aria-labelledby="pills-Executive-tab"
                >
                  <div class="row">
                    <div class="col-lg-8 mb-4 mb-lg-0">
                      <div class="ct_">
                        <h4 class="ct_fs_32 ct_darksky_blue_text ">
                          Executive & Leadership Packages
                        </h4>
                        <p class="mb-0 ct_fs_20">
                          Strengthen your leadership skills, make better
                          decisions, and lead with confidence at every level.
                        </p>
                      </div>
                      <div class="row mt-5">
                        <div class="col-lg-6  mb-4 mt-lg-4 mb-lg-0">
                          <div
                            class="ct_pricing_card"
                            style={{ borderColor: "#8ECAE6" }}
                          >
                            <div>
                              <div class="ct_pricing_title mt-3 text-start">
                                <p class="mb-2 ct_fs_24_new ct_yellow_text">
                                  Focus Pack
                                </p>
                                <h2 class="ct_fs_44  mb-0 ct_fw_600">{curSym} 250 </h2>
                                <p class="mb-0 mt-2 ct_fs_20 ct_darksky_blue_text">
                                  For managers
                                </p>
                              </div>
                              <ul class="ct_mt_30 mb-4 mt-4">
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  2 coaching sessions + leadership
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  style test
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Delegation & time audit
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Action checklist
                                </li>
                              </ul>
                            </div>
                            <div class="mt-auto pt-5">
                              <a
                                class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48"
                                onClick={() =>
                                  navigate(coachPaths.FindCoach, {
                                    state: { data: "Business" },
                                  })
                                }
                              >
                                Choose Plan
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6 mb-4 mb-lg-0">
                          <div
                            class="ct_pricing_card"
                            style={{ borderColor: "#8ECAE6" }}
                          >
                            <div>
                              <div class="ct_pricing_title mt-3 text-start">
                                <div class="d-flex align-items-center justify-content-between gap-2 mb-0">
                                  <p class="mb-2 ct_fs_24_new ct_yellow_text">
                                    Leadership Lab
                                  </p>
                                  <span class="ct_most_popular_badge ct_flex_shrink_0">
                                    Most Popular
                                  </span>
                                </div>
                                <h2 class="ct_fs_44  mb-0 ct_fw_600">{curSym} 520</h2>
                                <p class="mb-0 mt-2 ct_fs_20 ct_darksky_blue_text">
                                  For directors, and C-level professionals
                                </p>
                              </div>
                              <ul class="ct_mt_30 mb-4 mt-4">
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  6 sessions over 8 weeks
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Communication & conflict
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  coaching
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Team & process alignment Priority
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  leadership plan
                                </li>
                              </ul>
                            </div>
                            <div class="mt-auto">
                              <a
                                class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48"
                                onClick={() =>
                                  navigate(coachPaths.FindCoach, {
                                    state: { data: "Business" },
                                  })
                                }
                              >
                                Choose Plan
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 mb-4 mb-lg-0 ps-lg-3">
                      <div class="ct_about_img">
                        <img
                          src="assets/img/Rectangle_4187_12.png"
                          alt=""
                          class="ct_img_h_641"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${navBarDemo == "Team_Coaching" && "active show"
                    }`}
                  id="pills-Team_Coaching"
                  role="tabpanel"
                  aria-labelledby="pills-Team_Coaching-tab"
                >
                  <div class="row">
                    <div class="col-lg-8 mb-4 mb-lg-0">
                      <div class="ct_">
                        <h4 class="ct_fs_32 ct_yellow_text ">Team Packages</h4>
                        <p class="mb-0 ct_fs_20">
                          Align your team, improve communication, and build a
                          culture of trust and collaboration.
                        </p>
                      </div>
                      <div class="row mt-5">
                        <div class="col-lg-6 mt-lg-4  mb-4 mb-lg-0">
                          <div
                            class="ct_pricing_card"
                            style={{ borderColor: "#8ECAE6" }}
                          >
                            <div>
                              <div class="ct_pricing_title mt-3 text-start">
                                <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                  Team Pulse Workshop
                                </p>
                                <h2 class="ct_fs_44  mb-0 ct_fw_600">{curSym} 320 </h2>
                                <p class="mb-0 mt-2 ct_fs_20 ct_orange_text">
                                  For small teams seeking cohesion
                                </p>
                              </div>
                              <ul class="ct_mt_30 mb-4 mt-4">
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  1 group session (up to 4 members)
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Role clarity, shared values &
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  challenges
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Team feedback & strategy boar
                                </li>
                              </ul>
                            </div>
                            <div class="mt-auto pt-5">
                              <a
                                class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48"
                                onClick={() =>
                                  navigate(coachPaths.FindCoach, {
                                    state: { data: "Business" },
                                  })
                                }
                              >
                                Choose Plan
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6 mb-4 mb-lg-0">
                          <div
                            class="ct_pricing_card"
                            style={{ borderColor: "#8ECAE6" }}
                          >
                            <div>
                              <div class="ct_pricing_title mt-3 text-start">
                                <div class="d-flex align-items-center justify-content-between gap-2 mb-0">
                                  <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                    Team Evolution Program
                                  </p>
                                  <span
                                    class="ct_most_popular_badge ct_flex_shrink_0"
                                    style={{
                                      backgroundColor: "var(--yellow) ",
                                      color: "var(--darkblue)",
                                    }}
                                  >
                                    Most Popular
                                  </span>
                                </div>
                                <h2 class="ct_fs_44  mb-0 ct_fw_600">{curSym} 400</h2>
                                <p class="mb-0 mt-2 ct_fs_20 ct_orange_text">
                                  For small teams seeking clarity &
                                  collaboration
                                </p>
                              </div>
                              <ul class="ct_mt_30 mb-4 mt-4">
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  3 workshops + 2 leader 1:1s
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Communication & accountability
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  systems
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Execution roadmap
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Follow-up session after 30 days
                                </li>
                              </ul>
                            </div>
                            <div class="mt-auto">
                              <a
                                class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48"
                                onClick={() =>
                                  navigate(coachPaths.FindCoach, {
                                    state: { data: "Business" },
                                  })
                                }
                              >
                                Choose Plan
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 mb-4 mb-lg-0 ps-lg-3">
                      <div class="ct_about_img">
                        <img
                          src="assets/img/Rectangle_4187_new_one_223.png"
                          alt=""
                          class="ct_img_h_641"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${navBarDemo == "Performance" && "active show"
                    }`}
                  id="pills-Performance"
                  role="tabpanel"
                  aria-labelledby="pills-Performance-tab"
                >
                  <div class="row">
                    <div class="col-lg-8 mb-4 mb-lg-0">
                      <div class="ct_">
                        <h4 class="ct_fs_32 ct_sky_blue_text ">
                          Performance Packages
                        </h4>
                        <p class="mb-0 ct_fs_20" style={{ maxWidth: "787px" }}>
                          Break through blocks, stay accountable, and maintain
                          momentum toward your personal and professional goals.
                        </p>
                      </div>
                      <div class="row mt-5">
                        <div class="col-lg-6  mb-4 mb-lg-0">
                          <div
                            class="ct_pricing_card p-3"
                            style={{ borderColor: "#8ECAE6" }}
                          >
                            <div>
                              <div class="ct_pricing_title mt-3 text-start">
                                <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                  Boost Pack
                                </p>
                                <h2 class="ct_fs_44  mb-0 ct_fw_600">{curSym} 220 </h2>
                                <p class="mb-0 mt-2 ct_fs_20 ct_orange_text">
                                  For individuals or teams who want to boost
                                  productivity and sharpen performance.
                                </p>
                              </div>
                              <ul class="ct_mt_30 mb-4 mt-4">
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  2 × coaching sessions
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Personal productivity reset
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Energy + habit tracker
                                </li>
                              </ul>
                            </div>
                            <div class="mt-auto pt-5">
                              <a
                                class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48"
                                onClick={() =>
                                  navigate(coachPaths.FindCoach, {
                                    state: { data: "Business" },
                                  })
                                }
                              >
                                Choose Plan
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6 mb-4 mb-lg-0">
                          <div
                            class="ct_pricing_card p-3"
                            style={{ borderColor: "#8ECAE6" }}
                          >
                            <div>
                              <div class="ct_pricing_title mt-3 text-start">
                                <div class="d-flex align-items-center justify-content-between gap-2 mb-0">
                                  <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                    Performance Sprint
                                  </p>
                                  <span
                                    class="ct_most_popular_badge ct_flex_shrink_0"
                                    style={{
                                      backgroundColor: "var(--yellow) ",
                                      color: "var(--darkblue)",
                                    }}
                                  >
                                    Most Popular
                                  </span>
                                </div>
                                <h2 class="ct_fs_44  mb-0 ct_fw_600">{curSym} 480</h2>
                                <p class="mb-0 mt-2 ct_fs_20 ct_orange_text">
                                  For high performers and leaders ready to
                                  sustain growth and reach new potential.
                                </p>
                              </div>
                              <ul class="ct_mt_30 mb-4 mt-4">
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  6 sessions
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Mindset, resilience, and focus
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Goal system setup
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  WhatsApp accountability
                                </li>
                              </ul>
                            </div>
                            <div class="mt-auto">
                              <a
                                class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48"
                                onClick={() =>
                                  navigate(coachPaths.FindCoach, {
                                    state: { data: "Business" },
                                  })
                                }
                              >
                                Choose Plan
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 mb-4 mb-lg-0 ps-lg-3">
                      <div class="ct_about_img">
                        <img
                          src="assets/img/Rectangle_418_258963.png"
                          alt=""
                          class="ct_img_h_641"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${navBarDemo == "Strategic" && "active show"
                    }`}
                  id="pills-Strategic"
                  role="tabpanel"
                  aria-labelledby="pills-Strategic-tab"
                >
                  <div class="row">
                    <div class="col-lg-8 mb-4 mb-lg-0">
                      <div class="ct_">
                        <h4 class="ct_fs_32 ct_orange_text ">
                          Strategic Business Packages
                        </h4>
                        <p class="mb-0 ct_fs_20" style={{ maxWidth: "768px" }}>
                          Get expert guidance to scale your business with
                          smarter systems, better planning, and stronger
                          execution.
                        </p>
                      </div>
                      <div class="row mt-5">
                        <div class="col-lg-6  mb-4 mb-lg-0">
                          <div
                            class="ct_pricing_card"
                            style={{ borderColor: "#8ECAE6" }}
                          >
                            <div>
                              <div class="ct_pricing_title mt-3 text-start">
                                <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                  90-Day Roadmap
                                </p>
                                <h2 class="ct_fs_44  mb-0 ct_fw_600">{curSym} 380 </h2>
                                <p class="mb-0 mt-2 ct_fs_20 ct_orange_text">
                                  For entrepreneurs or teams seeking clarity and
                                  strategic direction.
                                </p>
                              </div>
                              <ul class="ct_mt_30 mb-4 mt-4">
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  3 sessions business review,
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  strategy, follow-up
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Funnel & positioning review
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  KPI setup
                                </li>
                              </ul>
                            </div>
                            <div class="mt-auto pt-5">
                              <a
                                class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48"
                                onClick={() =>
                                  navigate(coachPaths.FindCoach, {
                                    state: { data: "Business" },
                                  })
                                }
                              >
                                Choose Plan
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6 mb-4 mb-lg-0">
                          <div
                            class="ct_pricing_card"
                            style={{ borderColor: "#8ECAE6" }}
                          >
                            <div>
                              <div class="ct_pricing_title mt-3 text-start">
                                <div class="d-flex align-items-center justify-content-between gap-2 mb-0">
                                  <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                    ScaleUp Plan
                                  </p>
                                  <span
                                    class="ct_most_popular_badge ct_flex_shrink_0"
                                    style={{
                                      backgroundColor: "var(--yellow) ",
                                      color: "var(--darkblue)",
                                    }}
                                  >
                                    Most Popular
                                  </span>
                                </div>
                                <h2 class="ct_fs_44  mb-0 ct_fw_600">{curSym} 599</h2>
                                <p class="mb-0 mt-2 ct_fs_20 ct_orange_text">
                                  For founders and teams ready to scale with
                                  structure, confidence, and purpose.
                                </p>
                              </div>
                              <ul class="ct_mt_30 mb-4 mt-4">
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  8 strategy sessions over 3 months
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Revenue model optimization
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Team & process planning
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Strategic calendar
                                </li>
                              </ul>
                            </div>
                            <div class="mt-auto">
                              <a
                                class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48"
                                onClick={() =>
                                  navigate(coachPaths.FindCoach, {
                                    state: { data: "Business" },
                                  })
                                }
                              >
                                Choose Plan
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 mb-4 mb-lg-0 ps-lg-3">
                      <div class="ct_about_img">
                        <img
                          src="assets/img/Rectangle_4187_8597865.png"
                          alt=""
                          class="ct_img_h_641"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${navBarDemo == "Personal_Coaching" && "active show"
                    }`}
                  id="pills-Personal_Coaching"
                  role="tabpanel"
                  aria-labelledby="pills-Personal_Coaching-tab"
                >
                  <div class="row">
                    <div class="col-lg-12 mb-4 mb-lg-0">
                      <div class="">
                        <h4 class="ct_fs_32 ct_yellow_text ">
                          Personal Packages
                        </h4>
                        <p class="mb-0 ct_fs_20">
                          Find clarity, build self-trust, and unlock the
                          confidence you need to move forward in life or career.
                        </p>
                      </div>
                      <div class="row mt-5">
                        <div class="col-lg-4  mb-4 mb-lg-0">
                          <div
                            class="ct_pricing_card"
                            style={{ borderColor: "#8ECAE6" }}
                          >
                            <div>
                              <div class="ct_pricing_title mt-3 text-start">
                                <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                  Awareness Pack
                                </p>
                                <h2 class="ct_fs_44  mb-0 ct_fw_600">{curSym} 160 </h2>
                                <p class="mb-0 mt-2 ct_fs_20 ct_orange_text">
                                  For individuals seeking clarity, direction,
                                  and personal growth.
                                </p>
                              </div>
                              <ul class="ct_mt_30 mb-4 mt-4">
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  2 sessions
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Values & life clarity session
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Habit & mindset reset plan
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Support email after 2 week
                                </li>
                              </ul>
                            </div>
                            <div class="mt-auto pt-5">
                              <a
                                class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48"
                                onClick={() =>
                                  navigate(coachPaths.FindCoach, {
                                    state: { data: "Business" },
                                  })
                                }
                              >
                                Choose Plan
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 mb-4 mb-lg-0">
                          <div
                            class="ct_pricing_card"
                            style={{ borderColor: "#8ECAE6" }}
                          >
                            <div>
                              <div class="ct_pricing_title mt-3 text-start">
                                <div class="d-flex align-items-center justify-content-between gap-2 mb-0">
                                  <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                    Breakthrough Pack
                                  </p>
                                  <span
                                    class="ct_most_popular_badge ct_flex_shrink_0"
                                    style={{
                                      backgroundColor: "var(--yellow) ",
                                      color: "var(--darkblue)",
                                    }}
                                  >
                                    Most Popular
                                  </span>
                                </div>
                                <h2 class="ct_fs_44  mb-0 ct_fw_600">{curSym} 400</h2>
                                <p class="mb-0 mt-2 ct_fs_20 ct_orange_text">
                                  For individuals ready to gain momentum and
                                  align purpose with action.
                                </p>
                              </div>
                              <ul class="ct_mt_30 mb-4 mt-4">
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  5 sessions
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Confidence & decision-making
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  support
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Purpose alignment
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Life systems mapping
                                </li>
                              </ul>
                            </div>
                            <div class="mt-auto">
                              <a
                                class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48"
                                onClick={() =>
                                  navigate(coachPaths.FindCoach, {
                                    state: { data: "Business" },
                                  })
                                }
                              >
                                Choose Plan
                              </a>
                            </div>
                          </div>
                        </div>

                        <div class="col-lg-4  mb-4 mb-lg-0">
                          <div
                            class="ct_pricing_card"
                            style={{ borderColor: "#8ECAE6" }}
                          >
                            <div>
                              <div class="ct_pricing_title mt-3 text-start">
                                <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                  Transformation Pack
                                </p>
                                <h2 class="ct_fs_44  mb-0 ct_fw_600">{curSym} 680 </h2>
                                <p class="mb-0 mt-2 ct_fs_20 ct_orange_text">
                                  For individuals ready to elevate their
                                  identity, mindset, and leadership.
                                </p>
                              </div>
                              <ul class="ct_mt_30 mb-4 mt-4">
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  8 sessions over 3 months
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Deep identity work, beliefs, and
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  leadership
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  Routine & energy optimization
                                </li>
                                <li className="ct_fs_18">
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ backgroundColor: "#023047" }}
                                  ></i>{" "}
                                  WhatsApp + accountability tracker
                                </li>
                              </ul>
                            </div>
                            <div class="mt-auto pt-5">
                              <a
                                class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48"
                                onClick={() =>
                                  navigate(coachPaths.FindCoach, {
                                    state: { data: "Business" },
                                  })
                                }
                              >
                                Choose Plan
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        class="ct_looking_for_work_bg  ct_looking_for_work_bg_left     ct_p_111_y_106"
        style={{ backgroundColor: "#FB8500" }}
        data-aos="fade-left"
        data-aos-duration="1500"
      >
        <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4 class="ct_fs_36 mb-4">Still Navigating Your Next Move?</h4>
            <p class="mb-0 ct_fs_18" style={{ maxWidth: "655px" }}>
              Whether you’re refining your idea or gearing up to launch, the
              right coach can help you take smart, focused steps.
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a
              href="javascript:void(0)"
              class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
            >
              View Events
            </a>
          </div>
        </div>
      </section>

      {/* <section class="ct_px_40 ">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <h2 class="ct_fs_32 text-center mb-3">
                Meet your Founder Coaches
              </h2>
              <p class=" ct_fs_20 text-center">
                Experienced, relatable, and ready to help you launch with
                clarity.
              </p>
            </div>
          </div>
          <div class="row ct_mt_60">
            <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
              <figure class="ct_featured_coach_card">
                <div class="ct_featured_card_img">
                  <img src="assets/img/Featured_Coaches_img_1.jpg" />
                </div>
                <figcaption>
                  <h4 class="ct_fs_20 ct_fw_600 mb-1">Jason Reed</h4>
                  <p class="mb-0 ct_grey_text">Business Coach</p>
                </figcaption>
              </figure>
            </div>
            <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
              <figure class="ct_featured_coach_card">
                <div class="ct_featured_card_img">
                  <img src="assets/img/Featured_Coaches_img_2.jpg" />
                </div>
                <figcaption>
                  <h4 class="ct_fs_20 ct_fw_600 mb-1">Jason Reed</h4>
                  <p class="mb-0 ct_grey_text">Business Coach</p>
                </figcaption>
              </figure>
            </div>
            <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
              <figure class="ct_featured_coach_card">
                <div class="ct_featured_card_img">
                  <img src="assets/img/Featured_Coaches_img_3.jpg" />
                </div>
                <figcaption>
                  <h4 class="ct_fs_20 ct_fw_600 mb-1">Jason Reed</h4>
                  <p class="mb-0 ct_grey_text">Business Coach</p>
                </figcaption>
              </figure>
            </div>
            <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
              <figure class="ct_featured_coach_card">
                <div class="ct_featured_card_img">
                  <img src="assets/img/Featured_Coaches_img_4.jpg" />
                </div>
                <figcaption>
                  <h4 class="ct_fs_20 ct_fw_600 mb-1">Jason Reed</h4>
                  <p class="mb-0 ct_grey_text">Business Coach</p>
                </figcaption>
              </figure>
            </div>
          </div>
        </div>
      </section> */}
      {/* <section class="ct_looking_for_work_bg ct_mt_100 ct_pt_127_pb_97  ct_orange_bg">
        <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4 class="ct_fs_36 mb-3" style={{ maxWidth: "700px" }}>
              Build Something Real With a Coach by Your Side
            </h4>
            <p class="mb-0 ct_fs_18" style={{ maxWidth: "623px" }}>
              You don’t have to figure it all out alone. Work with a
              founder-focused coach who gets your challenges and help you move
              forward.
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a href="#" class="ct_yellow_btn ct_darkblue_btn ct_flex_1">
              Find Your Coach
            </a>
          </div>
        </div>
      </section> */}

      {getAllEBookList?.length != 0 && (
        <section class="ct_coach_created_bg ct_px_40 ">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12 text-center">
                <h2 class="ct_fs_32 ct_darkblue_text mb-3">
                  Coach-Created eBooks, Real-World Wisdom
                </h2>
                <p className="ct_fs_24_new mx-auto">
                  Get actionable insights, strategies, and tools straight from
                  the coaches who guide founders, leaders, and teams every day.
                </p>
              </div>
              <EBookSlider getAllEBookList={getAllEBookList} />
            </div>
          </div>
        </section>
      )}
      <section
        data-aos="fade-left"
        data-aos-duration="1500"
        class="ct_looking_for_work_bg     ct_p_111_y_106 ct_mt_100"
        style={{ backgroundColor: "#219EBC" }}
      >
        <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4 class="ct_fs_36 mb-4">
              Looking for More Support Beyond Coaching?
            </h4>
            <p class="mb-0 ct_fs_18 ct_fw_300" style={{ maxWidth: "645px" }}>
              From web design and marketing to sales strategy and customer
              experience, Nuvio offers everything you need to grow with clarity.
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a
              class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
            // onClick={() => navigate(coachPaths?.ContactUs)}
            >
              Explore Services
            </a>
          </div>
        </div>
      </section>

      {/* <footer class="ct_px_40 py-5">
        <div class="ct_footer_logo">
          <a href="#">
            <img src="assets/img/Nuvio_logo.png" alt="" />
          </a>
        </div>
        <div class="row pt-4">
          <div class="col-xxl-3 col-xl-2 col-md-6 mb-4">
            <div class="ct_footer_links">
              <h4 class="ct_fs_20 ct_darkblue_text mb-3">Navigation</h4>
              <ul>
                <li>
                  <a href="404.html">For Enterprises</a>
                </li>
                <li>
                  <a href="404.html">For Freelancers</a>
                </li>
                <li>
                  <a href="404.html">CoachHUB</a>
                </li>
                <li>
                  <a href="404.html">Funding</a>
                </li>
                <li>
                  <a href="404.html">About us</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xxl-3 col-xl-2 col-md-6 mb-4">
            <div class="ct_footer_links">
              <h4 class="ct_fs_20 ct_darkblue_text mb-3">Resources</h4>
              <ul>
                <li>
                  <a href="404.html">Blog</a>
                </li>
                <li>
                  <a href="404.html">Newsletter</a>
                </li>
                <li>
                  <a href="404.html">Tutorials</a>
                </li>
                <li>
                  <a href="404.html">Support</a>
                </li>
                <li>
                  <a href="404.html">Help Centre</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xxl-2 col-xl-3 col-md-6 mb-4">
            <div class="ct_footer_links">
              <h4 class="ct_fs_20 ct_darkblue_text mb-3">Get in Touch</h4>
              <ul>
                <li>
                  <a href="mailto:hello@nu-vio.com">
                    <i class="fa-solid fa-envelope me-1 ct_yellow_text"></i>
                    hello@nu-vio.com
                  </a>
                </li>
                <li>
                  <a href="tel:+123-456-789">
                    <i class="fa-solid fa-phone me-1 ct_yellow_text"></i>
                    +123-456-789
                  </a>
                </li>
                <li>
                  <a>
                    <i class="fa-solid fa-location-dot ct_yellow_text me-1"></i>{" "}
                   Office 36, 1 Exchange Building (TBE), Cybercity, Ebene Mauritius
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xxl-4 col-xl-5 col-md-6 mb-4">
            <div class="ct_newsletter_bg">
              <p>Ready to keep up with what’s next?</p>
              <div class="d-flex align-items-center gap-2 justify-content-between ct_flex_col_991">
                <div class="form-group ct_flex_1 ct_w_100_991">
                  <input
                    type="email"
                    class="form-control ct_input ct_border_radius_100"
                    placeholder="Enter your email address"
                  />
                </div>
                <div class="ct_w_100_991">
                  <button class="ct_yellow_btn ct_darkblue_btn ct_border_radius_100 ct_h_48 ct_w_100_991">
                    Subscribe now
                  </button>
                </div>
              </div>
            </div>
            <div class="pt-4">
              <h5 class="ct_fs_18 mb-3">Follow Us</h5>
              <div class="d-flex align-items-center gap-2">
                <a  style={{ color: "#0076B2" }}>
                  <i class="fa-brands fa-linkedin"></i>
                </a>
                <a  style={{ color: "#3D5A98" }}>
                  <i class="fa-brands fa-square-facebook"></i>
                </a>
                <a  style={{ color: "#FF0000" }}>
                  <i class="fa-brands fa-youtube"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="row pt-4 ct_border_top_1">
          <div class="col-md-12">
            <p class="mb-0 text-center">
              Copyright @ 2025 NUVIO All Rights Reserved
            </p>
          </div>
        </div>
      </footer> */}

      <div
        class="modal fade ct_submit_modal"
        id="ct_submit_modal"
        tabindex="-1"
        aria-labelledby="ct_submit_modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body py-5">
              <div class="mx-auto d-block text-center mb-4">
                <svg
                  width="80"
                  height="80"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                    fill="#FFB703"
                  />
                </svg>
              </div>
              <div class="text-center">
                <h4 class="ct_fs_20 ">Application Submitted</h4>
                <p>
                  Thanks for applying to become a coach on Nuvio CoachHUB. Our
                  team is currently reviewing your application
                </p>
              </div>
              <div class="text-center mt-4 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                <a class="ct_yellow_btn ct_outline_grey ct_h_48 px-5 ct_w_100_575">
                  View Coaches
                </a>
                <button
                  class="ct_yellow_btn ct_h_48  px-5 ct_w_100_575"
                  data-bs-dismiss="modal"
                >
                  Close{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ height: "100px" }}></div>
    </MenuLayout>
  );
}

export default BusinessCoaching